// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   KeepTrack Design Tokens
   Single source of truth for colors, spacing, typography,
   elevation, border-radius, and motion.
   ============================================================ */

:root {
  /* ---- Color Primitives ---- */
  --kt-gray-50: #fafafa;
  --kt-gray-100: #f0f0f0;
  --kt-gray-200: #e0e0e0;
  --kt-gray-300: #bdbdbd;
  --kt-gray-400: #9e9e9e;
  --kt-gray-500: #757575;
  --kt-gray-600: #616161;
  --kt-gray-700: #424242;
  --kt-gray-800: #303030;
  --kt-gray-900: #1f1f1f;
  --kt-gray-950: #141414;

  --kt-red-400: #e01a0e;
  --kt-red-500: #ba160c;
  --kt-red-600: #860f08;

  /* ---- Semantic: Backgrounds ---- */
  --kt-bg-primary: var(--kt-gray-900);
  --kt-bg-elevated: var(--kt-gray-800);
  --kt-bg-surface: var(--kt-gray-700);
  --kt-bg-hover: rgba(255, 255, 255, 0.08);
  --kt-bg-active: rgba(255, 255, 255, 0.12);

  /* ---- Semantic: Borders ---- */
  --kt-border-default: #3a3a3a;
  --kt-border-subtle: rgba(255, 255, 255, 0.05);
  --kt-border-strong: var(--kt-gray-600);

  /* ---- Semantic: Text ---- */
  --kt-text-primary: #f5f5f5;
  --kt-text-secondary: rgba(255, 255, 255, 0.7);
  --kt-text-tertiary: rgba(255, 255, 255, 0.45);
  --kt-text-accent: #dd382f;
  --kt-text-muted: #6b6b6b;

  /* ---- Semantic: Interactive ---- */
  --kt-accent: var(--kt-red-500);
  --kt-accent-light: var(--kt-red-400);
  --kt-accent-dark: var(--kt-red-600);

  /* ---- Spacing Scale (4px base) ---- */
  --kt-space-0: 0px;
  --kt-space-1: 4px;
  --kt-space-2: 8px;
  --kt-space-3: 12px;
  --kt-space-4: 16px;
  --kt-space-5: 20px;
  --kt-space-6: 24px;
  --kt-space-8: 32px;
  --kt-space-10: 40px;
  --kt-space-12: 48px;

  /* ---- Typography Scale ---- */
  --kt-font-xs: 11px;
  --kt-font-sm: 13px;
  --kt-font-base: 14px;
  --kt-font-md: 16px;
  --kt-font-lg: 18px;
  --kt-font-xl: 24px;

  /* ---- Border Radius ---- */
  --kt-radius-sm: 4px;
  --kt-radius-md: 6px;
  --kt-radius-lg: 8px;
  --kt-radius-xl: 12px;
  --kt-radius-full: 9999px;

  /* ---- Elevation (Shadows) ---- */
  --kt-shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.3);
  --kt-shadow-md: 0 4px 8px rgba(0, 0, 0, 0.4);
  --kt-shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.5);
  --kt-shadow-xl: 0 12px 40px rgba(0, 0, 0, 0.6);

  /* ---- Motion ---- */
  --kt-duration-instant: 0ms;
  --kt-duration-fast: 100ms;
  --kt-duration-normal: 200ms;
  --kt-duration-slow: 300ms;
  --kt-easing-default: cubic-bezier(0.4, 0, 0.2, 1);
  --kt-easing-enter: cubic-bezier(0, 0, 0.2, 1);
  --kt-easing-exit: cubic-bezier(0.4, 0, 1, 1);

  /* ---- Backward-Compatible Aliases ---- */
  --color-dark-background: var(--kt-bg-primary);
  --color-dark-border: var(--kt-border-default);
  --color-dark-text-accent: var(--kt-text-accent);
  --color-dark-text-muted: var(--kt-text-muted);
  --color-primary: var(--kt-red-500);
  --color-primary-light: var(--kt-red-400);
  --color-primary-dark: var(--kt-red-600);
}
`, "",{"version":3,"sources":["webpack://./public/css/design-tokens.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;;EAErB,oCAAoC;EACpC,mCAAmC;EACnC,oCAAoC;EACpC,mCAAmC;EACnC,wCAAwC;EACxC,yCAAyC;;EAEzC,gCAAgC;EAChC,4BAA4B;EAC5B,6CAA6C;EAC7C,sCAAsC;;EAEtC,6BAA6B;EAC7B,0BAA0B;EAC1B,6CAA6C;EAC7C,6CAA6C;EAC7C,yBAAyB;EACzB,wBAAwB;;EAExB,oCAAoC;EACpC,8BAA8B;EAC9B,oCAAoC;EACpC,mCAAmC;;EAEnC,uCAAuC;EACvC,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;;EAEnB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;EAElB,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;;EAExB,kCAAkC;EAClC,4CAA4C;EAC5C,4CAA4C;EAC5C,6CAA6C;EAC7C,8CAA8C;;EAE9C,qBAAqB;EACrB,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,iDAAiD;EACjD,6CAA6C;EAC7C,4CAA4C;;EAE5C,0CAA0C;EAC1C,6CAA6C;EAC7C,6CAA6C;EAC7C,+CAA+C;EAC/C,6CAA6C;EAC7C,kCAAkC;EAClC,wCAAwC;EACxC,uCAAuC;AACzC","sourcesContent":["/* ============================================================\n   KeepTrack Design Tokens\n   Single source of truth for colors, spacing, typography,\n   elevation, border-radius, and motion.\n   ============================================================ */\n\n:root {\n  /* ---- Color Primitives ---- */\n  --kt-gray-50: #fafafa;\n  --kt-gray-100: #f0f0f0;\n  --kt-gray-200: #e0e0e0;\n  --kt-gray-300: #bdbdbd;\n  --kt-gray-400: #9e9e9e;\n  --kt-gray-500: #757575;\n  --kt-gray-600: #616161;\n  --kt-gray-700: #424242;\n  --kt-gray-800: #303030;\n  --kt-gray-900: #1f1f1f;\n  --kt-gray-950: #141414;\n\n  --kt-red-400: #e01a0e;\n  --kt-red-500: #ba160c;\n  --kt-red-600: #860f08;\n\n  /* ---- Semantic: Backgrounds ---- */\n  --kt-bg-primary: var(--kt-gray-900);\n  --kt-bg-elevated: var(--kt-gray-800);\n  --kt-bg-surface: var(--kt-gray-700);\n  --kt-bg-hover: rgba(255, 255, 255, 0.08);\n  --kt-bg-active: rgba(255, 255, 255, 0.12);\n\n  /* ---- Semantic: Borders ---- */\n  --kt-border-default: #3a3a3a;\n  --kt-border-subtle: rgba(255, 255, 255, 0.05);\n  --kt-border-strong: var(--kt-gray-600);\n\n  /* ---- Semantic: Text ---- */\n  --kt-text-primary: #f5f5f5;\n  --kt-text-secondary: rgba(255, 255, 255, 0.7);\n  --kt-text-tertiary: rgba(255, 255, 255, 0.45);\n  --kt-text-accent: #dd382f;\n  --kt-text-muted: #6b6b6b;\n\n  /* ---- Semantic: Interactive ---- */\n  --kt-accent: var(--kt-red-500);\n  --kt-accent-light: var(--kt-red-400);\n  --kt-accent-dark: var(--kt-red-600);\n\n  /* ---- Spacing Scale (4px base) ---- */\n  --kt-space-0: 0px;\n  --kt-space-1: 4px;\n  --kt-space-2: 8px;\n  --kt-space-3: 12px;\n  --kt-space-4: 16px;\n  --kt-space-5: 20px;\n  --kt-space-6: 24px;\n  --kt-space-8: 32px;\n  --kt-space-10: 40px;\n  --kt-space-12: 48px;\n\n  /* ---- Typography Scale ---- */\n  --kt-font-xs: 11px;\n  --kt-font-sm: 13px;\n  --kt-font-base: 14px;\n  --kt-font-md: 16px;\n  --kt-font-lg: 18px;\n  --kt-font-xl: 24px;\n\n  /* ---- Border Radius ---- */\n  --kt-radius-sm: 4px;\n  --kt-radius-md: 6px;\n  --kt-radius-lg: 8px;\n  --kt-radius-xl: 12px;\n  --kt-radius-full: 9999px;\n\n  /* ---- Elevation (Shadows) ---- */\n  --kt-shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.3);\n  --kt-shadow-md: 0 4px 8px rgba(0, 0, 0, 0.4);\n  --kt-shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.5);\n  --kt-shadow-xl: 0 12px 40px rgba(0, 0, 0, 0.6);\n\n  /* ---- Motion ---- */\n  --kt-duration-instant: 0ms;\n  --kt-duration-fast: 100ms;\n  --kt-duration-normal: 200ms;\n  --kt-duration-slow: 300ms;\n  --kt-easing-default: cubic-bezier(0.4, 0, 0.2, 1);\n  --kt-easing-enter: cubic-bezier(0, 0, 0.2, 1);\n  --kt-easing-exit: cubic-bezier(0.4, 0, 1, 1);\n\n  /* ---- Backward-Compatible Aliases ---- */\n  --color-dark-background: var(--kt-bg-primary);\n  --color-dark-border: var(--kt-border-default);\n  --color-dark-text-accent: var(--kt-text-accent);\n  --color-dark-text-muted: var(--kt-text-muted);\n  --color-primary: var(--kt-red-500);\n  --color-primary-light: var(--kt-red-400);\n  --color-primary-dark: var(--kt-red-600);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
